import { jsx, jsxs } from 'react/jsx-runtime';
import { Colors } from '../../../theme/Colors.es.js';
import { Text } from '../../display/Text/Text.es.js';
import { Img } from '../../display/Img/Img.es.js';
import { LegacyColorMap } from '../../../theme/LegacyColorMap.es.js';

const root = "_root_fkb81_1";
const content = "_content_fkb81_17";
const text = "_text_fkb81_24";
const headingContainer = "_heading-container_fkb81_32";
const description = "_description_fkb81_41";
const styles = {
	root: root,
	content: content,
	text: text,
	headingContainer: headingContainer,
	description: description
};

const OneColumnBlock = ({ backgroundColor, altText = "", headingTag = "h3", heading, description, imageUrl, textAlign = "center" }) => {
  const textMarginLeft = textAlign === "center" || textAlign === "right" ? "auto" : 0;
  const textMarginRight = textAlign === "center" ? "auto" : 0;
  return jsx("div", { className: styles.root, "data-zds": true, style: {
    "--_zds-one-column-block-background-color": backgroundColor ? Colors[LegacyColorMap[backgroundColor]] : ""
  }, children: jsx("div", { className: styles.content, children: imageUrl ? jsx(Img, { borderRadius: "none", src: imageUrl, alt: altText }) : jsxs("div", { "data-testid": "Text", className: styles.text, "data-zds": true, style: {
    "--_zds-one-column-block-text-align": textAlign,
    "--_zds-one-column-block-margin-left": textMarginLeft,
    "--_zds-one-column-block-margin-right": textMarginRight
  }, children: [jsx("div", { className: styles.headingContainer, "data-zds": true, children: jsx(Text, { type: "heading", color: "GrayWarm10", tag: headingTag, children: heading }) }), description && jsx("div", { className: styles.description, "data-zds": true, children: description })] }) }) });
};

export { OneColumnBlock };
//# sourceMappingURL=OneColumnBlock.es.js.map
